import { format } from 'd3-format';
import { FormattedNumber } from 'react-intl';
import { path, pathOr } from 'ramda';

import { Timeslice } from 'scenes/Report/Report.helper';
import { Attribution } from './components/Attribution/Attribution.helper';

type CLOFBasedKeyMetric = {
  numberTransactions: number;
  salesAmount: number;
  periodStart: Date | string;
  periodEnd: Date | string;
  aov: number;
};

type CLOFBasedKeyMetrics = {
  result: CLOFBasedKeyMetric[];
  timeslice: Timeslice;
};

type Scale = {
  periodStart: string | number;
  y: number;
};

type SubscriberPurchasePattern = {
  merchantName: string;
  totalPurchases: string;
  numberOfTransactors: number;
  merchantTotal: number;
  percentOfMerchantTotal: number;
};

type QueryResponse = {
  data: {
    clofBasedKeyMetrics: CLOFBasedKeyMetrics;
    attributionByMerchant: Attribution;
    purchasesBySubWithMulPurchases: SubscriberPurchasePattern[];
  };
  loading: boolean;
};

type PageRoutes = {
  label: string;
  key: string;
  hash: string;
  Component?: any;
  options?: FormattedNumber.PropsBase;
  disabled?: boolean;
  hidden?: boolean;
  info?: string;
};

const chartMargin = {
  top: 20,
  bottom: 10,
};

const getTimeslice = path<string>(['data', 'clofBasedKeyMetrics', 'timeslice']);

const getResults = (dataType: string) => (response: QueryResponse) =>
  pathOr<CLOFBasedKeyMetric[]>([], ['data', dataType, 'result'], response);

const getAverages = path<Record<string, unknown>>([
  'data',
  'attributionByMerchant',
  'averageRates',
]);

const tickFormatter = (formatType = '$.0f') => (number: number) =>
  format(formatType)(number);

export {
  PageRoutes,
  QueryResponse,
  CLOFBasedKeyMetric,
  Scale,
  SubscriberPurchasePattern,
  getResults,
  tickFormatter,
  chartMargin,
  getTimeslice,
  getAverages,
};
